import React from 'react';

const ImagePlaceholder = ({ mobile, desktop }) => (
  <div className="isLoading">
    <picture>
      {desktop && <source srcSet={desktop} media="(min-width: 760px)" />}
      <img src={mobile} alt="cargando" />
    </picture>
    <span />
  </div>
);

export default ImagePlaceholder;
